export const SET_CANDLE_TYPE = 'SET_CANDLE_TYPE';
export const SET_HIST_LEN = 'SET_HIST_LEN';
export const SET_HORIZON = 'SET_HORIZON';

export const setCandleType = (candleType) => ({
  type: SET_CANDLE_TYPE,
  payload: candleType
});

export const sethistLen = (histLen) => ({
  type: SET_HIST_LEN,
  payload: histLen
});

export const setHorizon = (horizon) => ({
  type: SET_HORIZON,
  payload: horizon
});

export const setScore = (score) => ({
  type: 'SET_SCORE',
  payload: score,
});

export const setPlayMoney = (money) => ({
  type: 'SET_PLAY_MONEY',
  payload: money,
});

